module.exports = __webpack_public_path__ + "img/141.0ef35adb.jpg";